/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export const GET_PLATFORM_TYPES = 'GET_PLATFORM_TYPES';
export const GET_PLATFORM_TYPES_FAILURE = 'GET_PLATFORM_TYPES_FAILURE';
export const GET_PLATFORM_TYPES_SUCCESS = 'GET_PLATFORM_TYPES_SUCCESS';

export const GET_PLATFORM_TYPE = 'GET_PLATFORM_TYPE';
export const GET_PLATFORM_TYPE_SUCCESS = 'GET_PLATFORM_TYPE_SUCCESS';
export const GET_PLATFORM_TYPE_FAILURE = 'GET_PLATFORM_TYPE_FAILURE';

export const UPDATE_TYPES_TABLE_SORT = 'UPDATE_TYPES_TABLE_SORT';

export const UPDATE_PLATFORM_TYPE = 'UPDATE_PLATFORM_TYPE';
export const UPDATE_PLATFORM_TYPE_SUCCESS = 'UPDATE_PLATFORM_TYPE_SUCCESS';
export const UPDATE_PLATFORM_TYPE_FAILURE = 'UPDATE_PLATFORM_TYPE_FAILURE';

export const UPDATE_TYPE_SHOW_DELETE_CONFIRM = 'UPDATE_TYPE_SHOW_DELETE_CONFIRM';
export const DELETE_PLATFORM_TYPE = 'DELETE_PLATFORM_TYPE';
export const DELETE_PLATFORM_TYPE_SUCCESS = 'DELETE_PLATFORM_TYPE_SUCCESS';
export const DELETE_PLATFORM_TYPE_FAILURE = 'DELETE_PLATFORM_TYPE_FAILURE';

export const TYPES_TABLE_SET_PAGE = 'TYPES_TABLE_SET_PAGE';

export const START_PLATFORM_TYPE_DETAILS_EDIT_MODE = 'START_PLATFORM_TYPE_DETAILS_EDIT_MODE';
export const CANCEL_PLATFORM_TYPE_DETAILS_EDIT_MODE = 'CANCEL_PLATFORM_TYPE_DETAILS_EDIT_MODE';

export const GET_PLATFORM_TYPE_PI = 'GET_PLATFORM_TYPE_PI';
export const GET_PLATFORM_TYPE_PI_SUCCESS = 'GET_PLATFORM_TYPE_PI_SUCCESS';
export const GET_PLATFORM_TYPE_PI_FAILURE = 'GET_PLATFORM_TYPE_PI_FAILURE';

export const GET_PLATFORM_TYPE_ETS = 'GET_PLATFORM_TYPE_ETS';
export const GET_PLATFORM_TYPE_ETS_SUCCESS = 'GET_PLATFORM_TYPE_ETS_SUCCESS';
export const GET_PLATFORM_TYPE_ETS_FAILURE = 'GET_PLATFORM_TYPE_ETS_FAILURE';

export const GET_PLATFORM_TYPE_ETMS = 'GET_PLATFORM_TYPE_ETMS';
export const GET_PLATFORM_TYPE_ETMS_SUCCESS = 'GET_PLATFORM_TYPE_ETMS_SUCCESS';
export const GET_PLATFORM_TYPE_ETMS_FAILURE = 'GET_PLATFORM_TYPE_ETMS_FAILURE';

export const SAVE_PLATFORM_TYPE_DETAILS_EDITS = 'SAVE_PLATFORM_TYPE_DETAILS_EDITS';
export const SAVE_PLATFORM_TYPE_DETAILS_EDITS_SUCCESS = 'SAVE_PLATFORM_TYPE_DETAILS_EDITS_SUCCESS';
export const SAVE_PLATFORM_TYPE_DETAILS_EDITS_FAILURE = 'SAVE_PLATFORM_TYPE_DETAILS_EDITS_FAILURE';

export const GET_PLATFORM_TYPE_DIFF = 'GET_PLATFORM_TYPE_DIFF';
export const GET_PLATFORM_TYPE_DIFF_SUCCESS = 'GET_PLATFORM_TYPE_DIFF_SUCCESS';
export const GET_PLATFORM_TYPE_DIFF_FAILURE = 'GET_PLATFORM_TYPE_DIFF_FAILURE';

export const GET_PLATFORM_TYPE_VALIDATION = 'GET_PLATFORM_TYPE_VALIDATION';
export const GET_PLATFORM_TYPE_VALIDATION_SUCCESS = 'GET_PLATFORM_TYPE_VALIDATION_SUCCESS';
export const GET_PLATFORM_TYPE_VALIDATION_FAILURE = 'GET_PLATFORM_TYPE_VALIDATION_FAILURE';

export const SET_SELECTED_PI_EVENT_TYPE_ID = 'SET_SELECTED_PI_EVENT_TYPE_ID';

export const CLEAR_PLATFORM_TYPE_DETAILS = 'CLEAR_PLATFORM_TYPE_DETAILS';

export const SET_SELECTED_MAPPING_LI_ID = 'SET_SELECTED_MAPPING_LI_ID';

export const TYPES_TABLE_CLEAR_REDIRECT = 'TYPES_TABLE_CLEAR_REDIRECT';
export const TYPES_TABLE_CLEAR_SEARCH = 'TYPES_TABLE_CLEAR_SEARCH';

export const GET_PLATFORM_TYPE_MAPPINGS = 'GET_PLATFORM_TYPE_MAPPINGS';
export const GET_PLATFORM_TYPE_MAPPINGS_SUCCESS = 'GET_PLATFORM_TYPE_MAPPINGS_SUCCESS';
export const GET_PLATFORM_TYPE_MAPPINGS_FAILURE = 'GET_PLATFORM_TYPE_MAPPINGS_FAILURE';

export const GET_PLATFORM_TYPE_LIS = 'GET_PLATFORM_TYPE_LIS';
export const GET_PLATFORM_TYPE_LIS_SUCCESS = 'GET_PLATFORM_TYPE_LIS_SUCCESS';
export const GET_PLATFORM_TYPE_LIS_FAILURE = 'GET_PLATFORM_TYPE_LIS_FAILURE';

export const GET_PLATFORM_TYPE_SCHEMAS = 'GET_PLATFORM_TYPE_SCHEMAS';
export const GET_PLATFORM_TYPE_SCHEMAS_SUCCESS = 'GET_PLATFORM_TYPE_SCHEMAS_SUCCESS';
export const GET_PLATFORM_TYPE_SCHEMAS_FAILURE = 'GET_PLATFORM_TYPE_SCHEMAS_FAILURE';
